import React from 'react';
import useMortgage from "../../../../../../../../providers/mortgage/useMortgage";
import useMortgageUploadService from "../../../../../../../../providers/mortgage/useMortgageUploadService";
import {Button} from "antd";
import {useUploadAnnotator} from "../../../../../../../../providers/mortgage/uploads/UploadAnnotatorContext";

function OpenButton({uploadId, section}) {
    const mortgage = useMortgage()
    const {openAnnotator} = useUploadAnnotator()
    const uploadService = useMortgageUploadService()
    const upload = mortgage.uploads.find(item => item.id === uploadId)

    const open = async () => {
        const isUploadVerifiable = mortgage.mortgageUploads.apply.find(s => s.uploads.find(it => it.id === uploadId))?.verified?.isVerifiable;
        if (isUploadVerifiable) {
            await openAnnotator(uploadId)
        } else {
            await uploadService.open(upload)
        }

    }

    return (
        <>
            <Button size="small" onClick={open}>Open</Button>
        </>
    );
}

export default OpenButton;